import useIsMobile from "../../../hook/useIsMobile"
import LinkcallProcessMobile from "./LinkcallProcessMobile";
import LinkcallProcessPc from "./LinkcallProcessPc";

export default function BusinessChart() {

    const isMobile = useIsMobile();

    return (
        <section className='w-full top-space lg:bg-[#F4F4F4]'>
            <div className={`max-w-[1700px] mx-auto px-[3%] lg:py-[220px]`}>
                <div className=''>
                    <div className='text-center font-bold text-title2 lg:text-display2'>
                        주행 사고 실시간 감지 및 자동 구조요청 시스템
                    </div>

                    <div className='mt-[60px] px-[5%] py-[60px] lg:px-[60px] bg-[#FAFAFA] lg:bg-white lg:rounded-[28px]'>
                        <img 
                            className='lg:w-3/4 mx-auto'
                            src={`${process.env.REACT_APP_STATIC_URL}/images/main/process_chart.png`}
                        />
                    </div>
                </div>

                <div className='mt-[100px] lg:mt-[160px]'>

                    {
                        isMobile ? <LinkcallProcessMobile/> : <LinkcallProcessPc/>
                    }
                </div>
            </div>
        </section>
    )
}